module.exports = __webpack_public_path__ + "img/fortus.f38c0151.png";